module.exports = __webpack_public_path__ + "img/demo4.e483f8de.png";